import { render, staticRenderFns } from "./ShopSetting.vue?vue&type=template&id=ffb9f0d2&"
import script from "./ShopSetting.vue?vue&type=script&lang=ts&"
export * from "./ShopSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports